module.exports = __webpack_public_path__ + "static/media/50.4422c6d3.jpg";